import { A as Dn, C as xe, D as X, N as Lt, O as jn, S as W, T as Vn, _ as Hn, c as Fn, d as Bn, f as Wn, g as $, h as rt, k as $n, l as zn, m as Mt, n as qn, p as Un, r as ve, s as Yn, t as kt, u as Kn, v as mt, x as Dt, y as te } from "./base-0v5VelL-.mjs.js";
import { a as Xn, c as Gn, i as Zn, m as Jn, o as Qn, p as jt, r as gt, s as eo, t as to } from "./productCarousel-CYEeQGRz.mjs.js";
var no = [["path", {
  d: "m18 15-6-6-6 6",
  key: "153udz"
}]], oo = Yn("chevron-up", no), g = /* @__PURE__ */ Lt(Dn(), 1), it = /* @__PURE__ */ Lt($n(), 1), ro = [
  "top",
  "right",
  "bottom",
  "left"
], le = Math.min, U = Math.max, Le = Math.round, Ie = Math.floor, ee = (e) => ({
  x: e,
  y: e
}), io = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ge(e, t, n) {
  return U(e, le(t, n));
}
function oe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function re(e) {
  return e.split("-")[0];
}
function be(e) {
  return e.split("-")[1];
}
function st(e) {
  return e === "x" ? "y" : "x";
}
function at(e) {
  return e === "y" ? "height" : "width";
}
function Q(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function ct(e) {
  return st(Q(e));
}
function so(e, t, n) {
  n === void 0 && (n = !1);
  const o = be(e), r = ct(e), i = at(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Me(s)), [s, Me(s)];
}
function ao(e) {
  const t = Me(e);
  return [
    Ze(e),
    t,
    Ze(t)
  ];
}
function Ze(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
var wt = ["left", "right"], vt = ["right", "left"], co = ["top", "bottom"], lo = ["bottom", "top"];
function uo(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? vt : wt : t ? wt : vt;
    case "left":
    case "right":
      return t ? co : lo;
    default:
      return [];
  }
}
function fo(e, t, n, o) {
  const r = be(e);
  let i = uo(re(e), n === "start", o);
  return r && (i = i.map((s) => s + "-" + r), t && (i = i.concat(i.map(Ze)))), i;
}
function Me(e) {
  const t = re(e);
  return io[t] + e.slice(t.length);
}
function po(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Vt(e) {
  return typeof e != "number" ? po(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ke(e) {
  const { x: t, y: n, width: o, height: r } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function yt(e, t, n) {
  let { reference: o, floating: r } = e;
  const i = Q(t), s = ct(t), a = at(s), c = re(t), u = i === "y", l = o.x + o.width / 2 - r.width / 2, d = o.y + o.height / 2 - r.height / 2, m = o[a] / 2 - r[a] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: l,
        y: o.y - r.height
      };
      break;
    case "bottom":
      p = {
        x: l,
        y: o.y + o.height
      };
      break;
    case "right":
      p = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: o.x - r.width,
        y: d
      };
      break;
    default:
      p = {
        x: o.x,
        y: o.y
      };
  }
  switch (be(t)) {
    case "start":
      p[s] -= m * (n && u ? -1 : 1);
      break;
    case "end":
      p[s] += m * (n && u ? -1 : 1);
      break;
  }
  return p;
}
async function ho(e, t) {
  var n;
  t === void 0 && (t = {});
  const { x: o, y: r, platform: i, rects: s, elements: a, strategy: c } = e, { boundary: u = "clippingAncestors", rootBoundary: l = "viewport", elementContext: d = "floating", altBoundary: m = !1, padding: p = 0 } = oe(t, e), h = Vt(p), f = a[m ? d === "floating" ? "reference" : "floating" : d], y = ke(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(f))) == null || n ? f : f.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: l,
    strategy: c
  })), x = d === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, v = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), S = await (i.isElement == null ? void 0 : i.isElement(v)) ? await (i.getScale == null ? void 0 : i.getScale(v)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = ke(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: x,
    offsetParent: v,
    strategy: c
  }) : x);
  return {
    top: (y.top - b.top + h.top) / S.y,
    bottom: (b.bottom - y.bottom + h.bottom) / S.y,
    left: (y.left - b.left + h.left) / S.x,
    right: (b.right - y.right + h.right) / S.x
  };
}
var mo = 50, go = async (e, t, n) => {
  const { placement: o = "bottom", strategy: r = "absolute", middleware: i = [], platform: s } = n, a = s.detectOverflow ? s : {
    ...s,
    detectOverflow: ho
  }, c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), { x: l, y: d } = yt(u, o, c), m = o, p = 0;
  const h = {};
  for (let f = 0; f < i.length; f++) {
    const y = i[f];
    if (!y) continue;
    const { name: x, fn: v } = y, { x: S, y: b, data: E, reset: R } = await v({
      x: l,
      y: d,
      initialPlacement: o,
      placement: m,
      strategy: r,
      middlewareData: h,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    l = S ?? l, d = b ?? d, h[x] = {
      ...h[x],
      ...E
    }, R && p < mo && (p++, typeof R == "object" && (R.placement && (m = R.placement), R.rects && (u = R.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : R.rects), { x: l, y: d } = yt(u, m, c)), f = -1);
  }
  return {
    x: l,
    y: d,
    placement: m,
    strategy: r,
    middlewareData: h
  };
}, wo = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const { x: n, y: o, placement: r, rects: i, platform: s, elements: a, middlewareData: c } = t, { element: u, padding: l = 0 } = oe(e, t) || {};
    if (u == null) return {};
    const d = Vt(l), m = {
      x: n,
      y: o
    }, p = ct(r), h = at(p), f = await s.getDimensions(u), y = p === "y", x = y ? "top" : "left", v = y ? "bottom" : "right", S = y ? "clientHeight" : "clientWidth", b = i.reference[h] + i.reference[p] - m[p] - i.floating[h], E = m[p] - i.reference[p], R = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let N = R ? R[S] : 0;
    (!N || !await (s.isElement == null ? void 0 : s.isElement(R))) && (N = a.floating[S] || i.floating[h]);
    const k = b / 2 - E / 2, V = N / 2 - f[h] / 2 - 1, L = le(d[x], V), H = le(d[v], V), D = L, _ = N - f[h] - H, I = N / 2 - f[h] / 2 + k, F = Ge(D, I, _), A = !c.arrow && be(r) != null && I !== F && i.reference[h] / 2 - (I < D ? L : H) - f[h] / 2 < 0, T = A ? I < D ? I - D : I - _ : 0;
    return {
      [p]: m[p] + T,
      data: {
        [p]: F,
        centerOffset: I - F - T,
        ...A && { alignmentOffset: T }
      },
      reset: A
    };
  }
}), vo = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const { placement: r, middlewareData: i, rects: s, initialPlacement: a, platform: c, elements: u } = t, { mainAxis: l = !0, crossAxis: d = !0, fallbackPlacements: m, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: h = "none", flipAlignment: f = !0, ...y } = oe(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset) return {};
      const x = re(r), v = Q(a), S = re(a) === a, b = await (c.isRTL == null ? void 0 : c.isRTL(u.floating)), E = m || (S || !f ? [Me(a)] : ao(a)), R = h !== "none";
      !m && R && E.push(...fo(a, f, h, b));
      const N = [a, ...E], k = await c.detectOverflow(t, y), V = [];
      let L = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (l && V.push(k[x]), d) {
        const I = so(r, s, b);
        V.push(k[I[0]], k[I[1]]);
      }
      if (L = [...L, {
        placement: r,
        overflows: V
      }], !V.every((I) => I <= 0)) {
        var H, D;
        const I = (((H = i.flip) == null ? void 0 : H.index) || 0) + 1, F = N[I];
        if (F && (!(d === "alignment" && v !== Q(F)) || L.every((T) => Q(T.placement) === v ? T.overflows[0] > 0 : !0)))
          return {
            data: {
              index: I,
              overflows: L
            },
            reset: { placement: F }
          };
        let A = (D = L.filter((T) => T.overflows[0] <= 0).sort((T, P) => T.overflows[1] - P.overflows[1])[0]) == null ? void 0 : D.placement;
        if (!A) switch (p) {
          case "bestFit": {
            var _;
            const T = (_ = L.filter((P) => {
              if (R) {
                const j = Q(P.placement);
                return j === v || j === "y";
              }
              return !0;
            }).map((P) => [P.placement, P.overflows.filter((j) => j > 0).reduce((j, z) => j + z, 0)]).sort((P, j) => P[1] - j[1])[0]) == null ? void 0 : _[0];
            T && (A = T);
            break;
          }
          case "initialPlacement":
            A = a;
            break;
        }
        if (r !== A) return { reset: { placement: A } };
      }
      return {};
    }
  };
};
function xt(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function St(e) {
  return ro.some((t) => e[t] >= 0);
}
var yo = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const { rects: n, platform: o } = t, { strategy: r = "referenceHidden", ...i } = oe(e, t);
      switch (r) {
        case "referenceHidden": {
          const s = xt(await o.detectOverflow(t, {
            ...i,
            elementContext: "reference"
          }), n.reference);
          return { data: {
            referenceHiddenOffsets: s,
            referenceHidden: St(s)
          } };
        }
        case "escaped": {
          const s = xt(await o.detectOverflow(t, {
            ...i,
            altBoundary: !0
          }), n.floating);
          return { data: {
            escapedOffsets: s,
            escaped: St(s)
          } };
        }
        default:
          return {};
      }
    }
  };
}, Ht = /* @__PURE__ */ new Set(["left", "top"]);
async function xo(e, t) {
  const { placement: n, platform: o, elements: r } = e, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = re(n), a = be(n), c = Q(n) === "y", u = Ht.has(s) ? -1 : 1, l = i && c ? -1 : 1, d = oe(t, e);
  let { mainAxis: m, crossAxis: p, alignmentAxis: h } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof h == "number" && (p = a === "end" ? h * -1 : h), c ? {
    x: p * l,
    y: m * u
  } : {
    x: m * u,
    y: p * l
  };
}
var So = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const { x: r, y: i, placement: s, middlewareData: a } = t, c = await xo(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: r + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
}, bo = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const { x: n, y: o, placement: r, platform: i } = t, { mainAxis: s = !0, crossAxis: a = !1, limiter: c = { fn: (x) => {
        let { x: v, y: S } = x;
        return {
          x: v,
          y: S
        };
      } }, ...u } = oe(e, t), l = {
        x: n,
        y: o
      }, d = await i.detectOverflow(t, u), m = Q(re(r)), p = st(m);
      let h = l[p], f = l[m];
      if (s) {
        const x = p === "y" ? "top" : "left", v = p === "y" ? "bottom" : "right", S = h + d[x], b = h - d[v];
        h = Ge(S, h, b);
      }
      if (a) {
        const x = m === "y" ? "top" : "left", v = m === "y" ? "bottom" : "right", S = f + d[x], b = f - d[v];
        f = Ge(S, f, b);
      }
      const y = c.fn({
        ...t,
        [p]: h,
        [m]: f
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - o,
          enabled: {
            [p]: s,
            [m]: a
          }
        }
      };
    }
  };
}, Co = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const { x: n, y: o, placement: r, rects: i, middlewareData: s } = t, { offset: a = 0, mainAxis: c = !0, crossAxis: u = !0 } = oe(e, t), l = {
        x: n,
        y: o
      }, d = Q(r), m = st(d);
      let p = l[m], h = l[d];
      const f = oe(a, t), y = typeof f == "number" ? {
        mainAxis: f,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...f
      };
      if (c) {
        const S = m === "y" ? "height" : "width", b = i.reference[m] - i.floating[S] + y.mainAxis, E = i.reference[m] + i.reference[S] - y.mainAxis;
        p < b ? p = b : p > E && (p = E);
      }
      if (u) {
        var x, v;
        const S = m === "y" ? "width" : "height", b = Ht.has(re(r)), E = i.reference[d] - i.floating[S] + (b && ((x = s.offset) == null ? void 0 : x[d]) || 0) + (b ? 0 : y.crossAxis), R = i.reference[d] + i.reference[S] + (b ? 0 : ((v = s.offset) == null ? void 0 : v[d]) || 0) - (b ? y.crossAxis : 0);
        h < E ? h = E : h > R && (h = R);
      }
      return {
        [m]: p,
        [d]: h
      };
    }
  };
}, Ro = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const { placement: r, rects: i, platform: s, elements: a } = t, { apply: c = () => {
      }, ...u } = oe(e, t), l = await s.detectOverflow(t, u), d = re(r), m = be(r), p = Q(r) === "y", { width: h, height: f } = i.floating;
      let y, x;
      d === "top" || d === "bottom" ? (y = d, x = m === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (x = d, y = m === "end" ? "top" : "bottom");
      const v = f - l.top - l.bottom, S = h - l.left - l.right, b = le(f - l[y], v), E = le(h - l[x], S), R = !t.middlewareData.shift;
      let N = b, k = E;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (k = S), (o = t.middlewareData.shift) != null && o.enabled.y && (N = v), R && !m) {
        const L = U(l.left, 0), H = U(l.right, 0), D = U(l.top, 0), _ = U(l.bottom, 0);
        p ? k = h - 2 * (L !== 0 || H !== 0 ? L + H : U(l.left, l.right)) : N = f - 2 * (D !== 0 || _ !== 0 ? D + _ : U(l.top, l.bottom));
      }
      await c({
        ...t,
        availableWidth: k,
        availableHeight: N
      });
      const V = await s.getDimensions(a.floating);
      return h !== V.width || f !== V.height ? { reset: { rects: !0 } } : {};
    }
  };
};
function Ve() {
  return typeof window < "u";
}
function Ce(e) {
  return Ft(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Y(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function ne(e) {
  var t;
  return (t = (Ft(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ft(e) {
  return Ve() ? e instanceof Node || e instanceof Y(e).Node : !1;
}
function Z(e) {
  return Ve() ? e instanceof Element || e instanceof Y(e).Element : !1;
}
function ie(e) {
  return Ve() ? e instanceof HTMLElement || e instanceof Y(e).HTMLElement : !1;
}
function bt(e) {
  return !Ve() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Y(e).ShadowRoot;
}
function Te(e) {
  const { overflow: t, overflowX: n, overflowY: o, display: r } = J(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && r !== "inline" && r !== "contents";
}
function Po(e) {
  return /^(table|td|th)$/.test(Ce(e));
}
function He(e) {
  try {
    if (e.matches(":popover-open")) return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
var Eo = /transform|translate|scale|rotate|perspective|filter/, Ao = /paint|layout|strict|content/, pe = (e) => !!e && e !== "none", Ye;
function lt(e) {
  const t = Z(e) ? J(e) : e;
  return pe(t.transform) || pe(t.translate) || pe(t.scale) || pe(t.rotate) || pe(t.perspective) || !dt() && (pe(t.backdropFilter) || pe(t.filter)) || Eo.test(t.willChange || "") || Ao.test(t.contain || "");
}
function Oo(e) {
  let t = de(e);
  for (; ie(t) && !Se(t); ) {
    if (lt(t)) return t;
    if (He(t)) return null;
    t = de(t);
  }
  return null;
}
function dt() {
  return Ye == null && (Ye = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Ye;
}
function Se(e) {
  return /^(html|body|#document)$/.test(Ce(e));
}
function J(e) {
  return Y(e).getComputedStyle(e);
}
function Fe(e) {
  return Z(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function de(e) {
  if (Ce(e) === "html") return e;
  const t = e.assignedSlot || e.parentNode || bt(e) && e.host || ne(e);
  return bt(t) ? t.host : t;
}
function Bt(e) {
  const t = de(e);
  return Se(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ie(t) && Te(t) ? t : Bt(t);
}
function _e(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Bt(e), i = r === ((o = e.ownerDocument) == null ? void 0 : o.body), s = Y(r);
  if (i) {
    const a = Je(s);
    return t.concat(s, s.visualViewport || [], Te(r) ? r : [], a && n ? _e(a) : []);
  } else return t.concat(r, _e(r, [], n));
}
function Je(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Wt(e) {
  const t = J(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = ie(e), i = r ? e.offsetWidth : n, s = r ? e.offsetHeight : o, a = Le(n) !== i || Le(o) !== s;
  return a && (n = i, o = s), {
    width: n,
    height: o,
    $: a
  };
}
function ut(e) {
  return Z(e) ? e : e.contextElement;
}
function ye(e) {
  const t = ut(e);
  if (!ie(t)) return ee(1);
  const n = t.getBoundingClientRect(), { width: o, height: r, $: i } = Wt(t);
  let s = (i ? Le(n.width) : n.width) / o, a = (i ? Le(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
var _o = /* @__PURE__ */ ee(0);
function $t(e) {
  const t = Y(e);
  return !dt() || !t.visualViewport ? _o : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function To(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Y(e) ? !1 : t;
}
function he(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = ut(e);
  let s = ee(1);
  t && (o ? Z(o) && (s = ye(o)) : s = ye(e));
  const a = To(i, n, o) ? $t(i) : ee(0);
  let c = (r.left + a.x) / s.x, u = (r.top + a.y) / s.y, l = r.width / s.x, d = r.height / s.y;
  if (i) {
    const m = Y(i), p = o && Z(o) ? Y(o) : o;
    let h = m, f = Je(h);
    for (; f && o && p !== h; ) {
      const y = ye(f), x = f.getBoundingClientRect(), v = J(f), S = x.left + (f.clientLeft + parseFloat(v.paddingLeft)) * y.x, b = x.top + (f.clientTop + parseFloat(v.paddingTop)) * y.y;
      c *= y.x, u *= y.y, l *= y.x, d *= y.y, c += S, u += b, h = Y(f), f = Je(h);
    }
  }
  return ke({
    width: l,
    height: d,
    x: c,
    y: u
  });
}
function Be(e, t) {
  const n = Fe(e).scrollLeft;
  return t ? t.left + n : he(ne(e)).left + n;
}
function zt(e, t) {
  const n = e.getBoundingClientRect();
  return {
    x: n.left + t.scrollLeft - Be(e, n),
    y: n.top + t.scrollTop
  };
}
function Io(e) {
  let { elements: t, rect: n, offsetParent: o, strategy: r } = e;
  const i = r === "fixed", s = ne(o), a = t ? He(t.floating) : !1;
  if (o === s || a && i) return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = ee(1);
  const l = ee(0), d = ie(o);
  if ((d || !d && !i) && ((Ce(o) !== "body" || Te(s)) && (c = Fe(o)), d)) {
    const p = he(o);
    u = ye(o), l.x = p.x + o.clientLeft, l.y = p.y + o.clientTop;
  }
  const m = s && !d && !i ? zt(s, c) : ee(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + l.x + m.x,
    y: n.y * u.y - c.scrollTop * u.y + l.y + m.y
  };
}
function No(e) {
  return Array.from(e.getClientRects());
}
function Lo(e) {
  const t = ne(e), n = Fe(e), o = e.ownerDocument.body, r = U(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), i = U(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Be(e);
  const a = -n.scrollTop;
  return J(o).direction === "rtl" && (s += U(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: s,
    y: a
  };
}
var Ct = 25;
function Mo(e, t) {
  const n = Y(e), o = ne(e), r = n.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, a = 0, c = 0;
  if (r) {
    i = r.width, s = r.height;
    const l = dt();
    (!l || l && t === "fixed") && (a = r.offsetLeft, c = r.offsetTop);
  }
  const u = Be(o);
  if (u <= 0) {
    const l = o.ownerDocument, d = l.body, m = getComputedStyle(d), p = l.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, h = Math.abs(o.clientWidth - d.clientWidth - p);
    h <= Ct && (i -= h);
  } else u <= Ct && (i += u);
  return {
    width: i,
    height: s,
    x: a,
    y: c
  };
}
function ko(e, t) {
  const n = he(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, i = ie(e) ? ye(e) : ee(1);
  return {
    width: e.clientWidth * i.x,
    height: e.clientHeight * i.y,
    x: r * i.x,
    y: o * i.y
  };
}
function Rt(e, t, n) {
  let o;
  if (t === "viewport") o = Mo(e, n);
  else if (t === "document") o = Lo(ne(e));
  else if (Z(t)) o = ko(t, n);
  else {
    const r = $t(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return ke(o);
}
function qt(e, t) {
  const n = de(e);
  return n === t || !Z(n) || Se(n) ? !1 : J(n).position === "fixed" || qt(n, t);
}
function Do(e, t) {
  const n = t.get(e);
  if (n) return n;
  let o = _e(e, [], !1).filter((a) => Z(a) && Ce(a) !== "body"), r = null;
  const i = J(e).position === "fixed";
  let s = i ? de(e) : e;
  for (; Z(s) && !Se(s); ) {
    const a = J(s), c = lt(s);
    !c && a.position === "fixed" && (r = null), (i ? !c && !r : !c && a.position === "static" && r && (r.position === "absolute" || r.position === "fixed") || Te(s) && !c && qt(e, s)) ? o = o.filter((u) => u !== s) : r = a, s = de(s);
  }
  return t.set(e, o), o;
}
function jo(e) {
  let { element: t, boundary: n, rootBoundary: o, strategy: r } = e;
  const i = [...n === "clippingAncestors" ? He(t) ? [] : Do(t, this._c) : [].concat(n), o], s = Rt(t, i[0], r);
  let a = s.top, c = s.right, u = s.bottom, l = s.left;
  for (let d = 1; d < i.length; d++) {
    const m = Rt(t, i[d], r);
    a = U(m.top, a), c = le(m.right, c), u = le(m.bottom, u), l = U(m.left, l);
  }
  return {
    width: c - l,
    height: u - a,
    x: l,
    y: a
  };
}
function Vo(e) {
  const { width: t, height: n } = Wt(e);
  return {
    width: t,
    height: n
  };
}
function Ho(e, t, n) {
  const o = ie(t), r = ne(t), i = n === "fixed", s = he(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = ee(0);
  function u() {
    c.x = Be(r);
  }
  if (o || !o && !i)
    if ((Ce(t) !== "body" || Te(r)) && (a = Fe(t)), o) {
      const d = he(t, !0, i, t);
      c.x = d.x + t.clientLeft, c.y = d.y + t.clientTop;
    } else r && u();
  i && !o && r && u();
  const l = r && !o && !i ? zt(r, a) : ee(0);
  return {
    x: s.left + a.scrollLeft - c.x - l.x,
    y: s.top + a.scrollTop - c.y - l.y,
    width: s.width,
    height: s.height
  };
}
function Ke(e) {
  return J(e).position === "static";
}
function Pt(e, t) {
  if (!ie(e) || J(e).position === "fixed") return null;
  if (t) return t(e);
  let n = e.offsetParent;
  return ne(e) === n && (n = n.ownerDocument.body), n;
}
function Ut(e, t) {
  const n = Y(e);
  if (He(e)) return n;
  if (!ie(e)) {
    let r = de(e);
    for (; r && !Se(r); ) {
      if (Z(r) && !Ke(r)) return r;
      r = de(r);
    }
    return n;
  }
  let o = Pt(e, t);
  for (; o && Po(o) && Ke(o); ) o = Pt(o, t);
  return o && Se(o) && Ke(o) && !lt(o) ? n : o || Oo(e) || n;
}
var Fo = async function(e) {
  const t = this.getOffsetParent || Ut, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Ho(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Bo(e) {
  return J(e).direction === "rtl";
}
var Wo = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Io,
  getDocumentElement: ne,
  getClippingRect: jo,
  getOffsetParent: Ut,
  getElementRects: Fo,
  getClientRects: No,
  getDimensions: Vo,
  getScale: ye,
  isElement: Z,
  isRTL: Bo
};
function Yt(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function $o(e, t) {
  let n = null, o;
  const r = ne(e);
  function i() {
    var a;
    clearTimeout(o), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), i();
    const u = e.getBoundingClientRect(), { left: l, top: d, width: m, height: p } = u;
    if (a || t(), !m || !p) return;
    const h = Ie(d), f = Ie(r.clientWidth - (l + m)), y = Ie(r.clientHeight - (d + p)), x = Ie(l), v = {
      rootMargin: -h + "px " + -f + "px " + -y + "px " + -x + "px",
      threshold: U(0, le(1, c)) || 1
    };
    let S = !0;
    function b(E) {
      const R = E[0].intersectionRatio;
      if (R !== c) {
        if (!S) return s();
        R ? s(!1, R) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      R === 1 && !Yt(u, e.getBoundingClientRect()) && s(), S = !1;
    }
    try {
      n = new IntersectionObserver(b, {
        ...v,
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(b, v);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function zo(e, t, n, o) {
  o === void 0 && (o = {});
  const { ancestorScroll: r = !0, ancestorResize: i = !0, elementResize: s = typeof ResizeObserver == "function", layoutShift: a = typeof IntersectionObserver == "function", animationFrame: c = !1 } = o, u = ut(e), l = r || i ? [...u ? _e(u) : [], ...t ? _e(t) : []] : [];
  l.forEach((x) => {
    r && x.addEventListener("scroll", n, { passive: !0 }), i && x.addEventListener("resize", n);
  });
  const d = u && a ? $o(u, n) : null;
  let m = -1, p = null;
  s && (p = new ResizeObserver((x) => {
    let [v] = x;
    v && v.target === u && p && t && (p.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var S;
      (S = p) == null || S.observe(t);
    })), n();
  }), u && !c && p.observe(u), t && p.observe(t));
  let h, f = c ? he(e) : null;
  c && y();
  function y() {
    const x = he(e);
    f && !Yt(f, x) && n(), f = x, h = requestAnimationFrame(y);
  }
  return n(), () => {
    var x;
    l.forEach((v) => {
      r && v.removeEventListener("scroll", n), i && v.removeEventListener("resize", n);
    }), d?.(), (x = p) == null || x.disconnect(), p = null, c && cancelAnimationFrame(h);
  };
}
var qo = So, Uo = bo, Yo = vo, Ko = Ro, Xo = yo, Et = wo, Go = Co, Zo = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Wo,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return go(e, t, {
    ...r,
    platform: i
  });
}, Ne = typeof document < "u" ? g.useLayoutEffect : function() {
};
function De(e, t) {
  if (e === t) return !0;
  if (typeof e != typeof t) return !1;
  if (typeof e == "function" && e.toString() === t.toString()) return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; ) if (!De(e[o], t[o])) return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length) return !1;
    for (o = n; o-- !== 0; ) if (!{}.hasOwnProperty.call(t, r[o])) return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && e.$$typeof) && !De(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Kt(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function At(e, t) {
  const n = Kt(e);
  return Math.round(t * n) / n;
}
function Xe(e) {
  const t = g.useRef(e);
  return Ne(() => {
    t.current = e;
  }), t;
}
function Jo(e) {
  e === void 0 && (e = {});
  const { placement: t = "bottom", strategy: n = "absolute", middleware: o = [], platform: r, elements: { reference: i, floating: s } = {}, transform: a = !0, whileElementsMounted: c, open: u } = e, [l, d] = g.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, p] = g.useState(o);
  De(m, o) || p(o);
  const [h, f] = g.useState(null), [y, x] = g.useState(null), v = g.useCallback((P) => {
    P !== R.current && (R.current = P, f(P));
  }, []), S = g.useCallback((P) => {
    P !== N.current && (N.current = P, x(P));
  }, []), b = i || h, E = s || y, R = g.useRef(null), N = g.useRef(null), k = g.useRef(l), V = c != null, L = Xe(c), H = Xe(r), D = Xe(u), _ = g.useCallback(() => {
    if (!R.current || !N.current) return;
    const P = {
      placement: t,
      strategy: n,
      middleware: m
    };
    H.current && (P.platform = H.current), Zo(R.current, N.current, P).then((j) => {
      const z = {
        ...j,
        isPositioned: D.current !== !1
      };
      I.current && !De(k.current, z) && (k.current = z, it.flushSync(() => {
        d(z);
      }));
    });
  }, [
    m,
    t,
    n,
    H,
    D
  ]);
  Ne(() => {
    u === !1 && k.current.isPositioned && (k.current.isPositioned = !1, d((P) => ({
      ...P,
      isPositioned: !1
    })));
  }, [u]);
  const I = g.useRef(!1);
  Ne(() => (I.current = !0, () => {
    I.current = !1;
  }), []), Ne(() => {
    if (b && (R.current = b), E && (N.current = E), b && E) {
      if (L.current) return L.current(b, E, _);
      _();
    }
  }, [
    b,
    E,
    _,
    L,
    V
  ]);
  const F = g.useMemo(() => ({
    reference: R,
    floating: N,
    setReference: v,
    setFloating: S
  }), [v, S]), A = g.useMemo(() => ({
    reference: b,
    floating: E
  }), [b, E]), T = g.useMemo(() => {
    const P = {
      position: n,
      left: 0,
      top: 0
    };
    if (!A.floating) return P;
    const j = At(A.floating, l.x), z = At(A.floating, l.y);
    return a ? {
      ...P,
      transform: "translate(" + j + "px, " + z + "px)",
      ...Kt(A.floating) >= 1.5 && { willChange: "transform" }
    } : {
      position: n,
      left: j,
      top: z
    };
  }, [
    n,
    a,
    A.floating,
    l.x,
    l.y
  ]);
  return g.useMemo(() => ({
    ...l,
    update: _,
    refs: F,
    elements: A,
    floatingStyles: T
  }), [
    l,
    _,
    F,
    A,
    T
  ]);
}
var Qo = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const { element: o, padding: r } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? Et({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? Et({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, er = (e, t) => {
  const n = qo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, tr = (e, t) => {
  const n = Uo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, nr = (e, t) => ({
  fn: Go(e).fn,
  options: [e, t]
}), or = (e, t) => {
  const n = Yo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, rr = (e, t) => {
  const n = Ko(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, ir = (e, t) => {
  const n = Xo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, sr = (e, t) => {
  const n = Qo(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, w = Vn(), ar = "Arrow", Xt = g.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...i } = e;
  return /* @__PURE__ */ (0, w.jsx)($.svg, {
    ...i,
    ref: t,
    width: o,
    height: r,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none",
    children: e.asChild ? n : /* @__PURE__ */ (0, w.jsx)("polygon", { points: "0,0 30,0 15,10" })
  });
});
Xt.displayName = ar;
var cr = Xt, ft = "Popper", [Gt, Zt] = Dt(ft), [lr, Jt] = Gt(ft), Qt = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = g.useState(null);
  return /* @__PURE__ */ (0, w.jsx)(lr, {
    scope: t,
    anchor: o,
    onAnchorChange: r,
    children: n
  });
};
Qt.displayName = ft;
var en = "PopperAnchor", tn = g.forwardRef((e, t) => {
  const { __scopePopper: n, virtualRef: o, ...r } = e, i = Jt(en, n), s = g.useRef(null), a = X(t, s), c = g.useRef(null);
  return g.useEffect(() => {
    const u = c.current;
    c.current = o?.current || s.current, u !== c.current && i.onAnchorChange(c.current);
  }), o ? null : /* @__PURE__ */ (0, w.jsx)($.div, {
    ...r,
    ref: a
  });
});
tn.displayName = en;
var pt = "PopperContent", [dr, ur] = Gt(pt), nn = g.forwardRef((e, t) => {
  const { __scopePopper: n, side: o = "bottom", sideOffset: r = 0, align: i = "center", alignOffset: s = 0, arrowPadding: a = 0, avoidCollisions: c = !0, collisionBoundary: u = [], collisionPadding: l = 0, sticky: d = "partial", hideWhenDetached: m = !1, updatePositionStrategy: p = "optimized", onPlaced: h, ...f } = e, y = Jt(pt, n), [x, v] = g.useState(null), S = X(t, (C) => v(C)), [b, E] = g.useState(null), R = Qn(b), N = R?.width ?? 0, k = R?.height ?? 0, V = o + (i !== "center" ? "-" + i : ""), L = typeof l == "number" ? l : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...l
  }, H = Array.isArray(u) ? u : [u], D = H.length > 0, _ = {
    padding: L,
    boundary: H.filter(pr),
    altBoundary: D
  }, { refs: I, floatingStyles: F, placement: A, isPositioned: T, middlewareData: P } = Jo({
    strategy: "fixed",
    placement: V,
    whileElementsMounted: (...C) => zo(...C, { animationFrame: p === "always" }),
    elements: { reference: y.anchor },
    middleware: [
      er({
        mainAxis: r + k,
        alignmentAxis: s
      }),
      c && tr({
        mainAxis: !0,
        crossAxis: !1,
        limiter: d === "partial" ? nr() : void 0,
        ..._
      }),
      c && or({ ..._ }),
      rr({
        ..._,
        apply: ({ elements: C, rects: B, availableWidth: M, availableHeight: O }) => {
          const { width: K, height: q } = B.reference, ce = C.floating.style;
          ce.setProperty("--radix-popper-available-width", `${M}px`), ce.setProperty("--radix-popper-available-height", `${O}px`), ce.setProperty("--radix-popper-anchor-width", `${K}px`), ce.setProperty("--radix-popper-anchor-height", `${q}px`);
        }
      }),
      b && sr({
        element: b,
        padding: a
      }),
      hr({
        arrowWidth: N,
        arrowHeight: k
      }),
      m && ir({
        strategy: "referenceHidden",
        ..._
      })
    ]
  }), [j, z] = sn(A), we = Mt(h);
  te(() => {
    T && we?.();
  }, [T, we]);
  const Pe = P.arrow?.x, se = P.arrow?.y, Ee = P.arrow?.centerOffset !== 0, [ae, Ae] = g.useState();
  return te(() => {
    x && Ae(window.getComputedStyle(x).zIndex);
  }, [x]), /* @__PURE__ */ (0, w.jsx)("div", {
    ref: I.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...F,
      transform: T ? F.transform : "translate(0, -200%)",
      minWidth: "max-content",
      zIndex: ae,
      "--radix-popper-transform-origin": [P.transformOrigin?.x, P.transformOrigin?.y].join(" "),
      ...P.hide?.referenceHidden && {
        visibility: "hidden",
        pointerEvents: "none"
      }
    },
    dir: e.dir,
    children: /* @__PURE__ */ (0, w.jsx)(dr, {
      scope: n,
      placedSide: j,
      onArrowChange: E,
      arrowX: Pe,
      arrowY: se,
      shouldHideArrow: Ee,
      children: /* @__PURE__ */ (0, w.jsx)($.div, {
        "data-side": j,
        "data-align": z,
        ...f,
        ref: S,
        style: {
          ...f.style,
          animation: T ? void 0 : "none"
        }
      })
    })
  });
});
nn.displayName = pt;
var on = "PopperArrow", fr = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, rn = g.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, i = ur(on, o), s = fr[i.placedSide];
  return /* @__PURE__ */ (0, w.jsx)("span", {
    ref: i.onArrowChange,
    style: {
      position: "absolute",
      left: i.arrowX,
      top: i.arrowY,
      [s]: 0,
      transformOrigin: {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0"
      }[i.placedSide],
      transform: {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: "rotate(180deg)",
        left: "translateY(50%) rotate(-90deg) translateX(50%)"
      }[i.placedSide],
      visibility: i.shouldHideArrow ? "hidden" : void 0
    },
    children: /* @__PURE__ */ (0, w.jsx)(cr, {
      ...r,
      ref: n,
      style: {
        ...r.style,
        display: "block"
      }
    })
  });
});
rn.displayName = on;
function pr(e) {
  return e !== null;
}
var hr = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: n, rects: o, middlewareData: r } = t, i = r.arrow?.centerOffset !== 0, s = i ? 0 : e.arrowWidth, a = i ? 0 : e.arrowHeight, [c, u] = sn(n), l = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[u], d = (r.arrow?.x ?? 0) + s / 2, m = (r.arrow?.y ?? 0) + a / 2;
    let p = "", h = "";
    return c === "bottom" ? (p = i ? l : `${d}px`, h = `${-a}px`) : c === "top" ? (p = i ? l : `${d}px`, h = `${o.floating.height + a}px`) : c === "right" ? (p = `${-a}px`, h = i ? l : `${m}px`) : c === "left" && (p = `${o.floating.width + a}px`, h = i ? l : `${m}px`), { data: {
      x: p,
      y: h
    } };
  }
});
function sn(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var mr = Qt, gr = tn, wr = nn, vr = rn, an = Object.freeze({
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), yr = "VisuallyHidden", xr = g.forwardRef((e, t) => /* @__PURE__ */ (0, w.jsx)($.span, {
  ...e,
  ref: t,
  style: {
    ...an,
    ...e.style
  }
}));
xr.displayName = yr;
var Sr = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], br = [" ", "Enter"], me = "Select", [We, $e, Cr] = Xn(me), [Re, Ei] = Dt(me, [Cr, Zt]), ze = Zt(), [Rr, ue] = Re(me), [Pr, Er] = Re(me), cn = (e) => {
  const { __scopeSelect: t, children: n, open: o, defaultOpen: r, onOpenChange: i, value: s, defaultValue: a, onValueChange: c, dir: u, name: l, autoComplete: d, disabled: m, required: p, form: h } = e, f = ze(t), [y, x] = g.useState(null), [v, S] = g.useState(null), [b, E] = g.useState(!1), R = Zn(u), [N, k] = mt({
    prop: o,
    defaultProp: r ?? !1,
    onChange: i,
    caller: me
  }), [V, L] = mt({
    prop: s,
    defaultProp: a,
    onChange: c,
    caller: me
  }), H = g.useRef(null), D = y ? h || !!y.closest("form") : !0, [_, I] = g.useState(/* @__PURE__ */ new Set()), F = Array.from(_).map((A) => A.props.value).join(";");
  return /* @__PURE__ */ (0, w.jsx)(mr, {
    ...f,
    children: /* @__PURE__ */ (0, w.jsxs)(Rr, {
      required: p,
      scope: t,
      trigger: y,
      onTriggerChange: x,
      valueNode: v,
      onValueNodeChange: S,
      valueNodeHasChildren: b,
      onValueNodeHasChildrenChange: E,
      contentId: rt(),
      value: V,
      onValueChange: L,
      open: N,
      onOpenChange: k,
      dir: R,
      triggerPointerDownPosRef: H,
      disabled: m,
      children: [/* @__PURE__ */ (0, w.jsx)(We.Provider, {
        scope: t,
        children: /* @__PURE__ */ (0, w.jsx)(Pr, {
          scope: e.__scopeSelect,
          onNativeOptionAdd: g.useCallback((A) => {
            I((T) => new Set(T).add(A));
          }, []),
          onNativeOptionRemove: g.useCallback((A) => {
            I((T) => {
              const P = new Set(T);
              return P.delete(A), P;
            });
          }, []),
          children: n
        })
      }), D ? /* @__PURE__ */ (0, w.jsxs)(_n, {
        "aria-hidden": !0,
        required: p,
        tabIndex: -1,
        name: l,
        autoComplete: d,
        value: V,
        onChange: (A) => L(A.target.value),
        disabled: m,
        form: h,
        children: [V === void 0 ? /* @__PURE__ */ (0, w.jsx)("option", { value: "" }) : null, Array.from(_)]
      }, F) : null]
    })
  });
};
cn.displayName = me;
var ln = "SelectTrigger", dn = g.forwardRef((e, t) => {
  const { __scopeSelect: n, disabled: o = !1, ...r } = e, i = ze(n), s = ue(ln, n), a = s.disabled || o, c = X(t, s.onTriggerChange), u = $e(n), l = g.useRef("touch"), [d, m, p] = In((f) => {
    const y = u().filter((v) => !v.disabled), x = Nn(y, f, y.find((v) => v.value === s.value));
    x !== void 0 && s.onValueChange(x.value);
  }), h = (f) => {
    a || (s.onOpenChange(!0), p()), f && (s.triggerPointerDownPosRef.current = {
      x: Math.round(f.pageX),
      y: Math.round(f.pageY)
    });
  };
  return /* @__PURE__ */ (0, w.jsx)(gr, {
    asChild: !0,
    ...i,
    children: /* @__PURE__ */ (0, w.jsx)($.button, {
      type: "button",
      role: "combobox",
      "aria-controls": s.contentId,
      "aria-expanded": s.open,
      "aria-required": s.required,
      "aria-autocomplete": "none",
      dir: s.dir,
      "data-state": s.open ? "open" : "closed",
      disabled: a,
      "data-disabled": a ? "" : void 0,
      "data-placeholder": Tn(s.value) ? "" : void 0,
      ...r,
      ref: c,
      onClick: W(r.onClick, (f) => {
        f.currentTarget.focus(), l.current !== "mouse" && h(f);
      }),
      onPointerDown: W(r.onPointerDown, (f) => {
        l.current = f.pointerType;
        const y = f.target;
        y.hasPointerCapture(f.pointerId) && y.releasePointerCapture(f.pointerId), f.button === 0 && f.ctrlKey === !1 && f.pointerType === "mouse" && (h(f), f.preventDefault());
      }),
      onKeyDown: W(r.onKeyDown, (f) => {
        const y = d.current !== "";
        !(f.ctrlKey || f.altKey || f.metaKey) && f.key.length === 1 && m(f.key), !(y && f.key === " ") && Sr.includes(f.key) && (h(), f.preventDefault());
      })
    })
  });
});
dn.displayName = ln;
var un = "SelectValue", Ar = g.forwardRef((e, t) => {
  const { __scopeSelect: n, className: o, style: r, children: i, placeholder: s = "", ...a } = e, c = ue(un, n), { onValueNodeHasChildrenChange: u } = c, l = i !== void 0, d = X(t, c.onValueNodeChange);
  return te(() => {
    u(l);
  }, [u, l]), /* @__PURE__ */ (0, w.jsx)($.span, {
    ...a,
    ref: d,
    style: { pointerEvents: "none" },
    children: Tn(c.value) ? /* @__PURE__ */ (0, w.jsx)(w.Fragment, { children: s }) : i
  });
});
Ar.displayName = un;
var Or = "SelectIcon", fn = g.forwardRef((e, t) => {
  const { __scopeSelect: n, children: o, ...r } = e;
  return /* @__PURE__ */ (0, w.jsx)($.span, {
    "aria-hidden": !0,
    ...r,
    ref: t,
    children: o || "▼"
  });
});
fn.displayName = Or;
var _r = "SelectPortal", pn = (e) => /* @__PURE__ */ (0, w.jsx)(Bn, {
  asChild: !0,
  ...e
});
pn.displayName = _r;
var ge = "SelectContent", hn = g.forwardRef((e, t) => {
  const n = ue(ge, e.__scopeSelect), [o, r] = g.useState();
  if (te(() => {
    r(new DocumentFragment());
  }, []), !n.open) {
    const i = o;
    return i ? it.createPortal(/* @__PURE__ */ (0, w.jsx)(mn, {
      scope: e.__scopeSelect,
      children: /* @__PURE__ */ (0, w.jsx)(We.Slot, {
        scope: e.__scopeSelect,
        children: /* @__PURE__ */ (0, w.jsx)("div", { children: e.children })
      })
    }), i) : null;
  }
  return /* @__PURE__ */ (0, w.jsx)(gn, {
    ...e,
    ref: t
  });
});
hn.displayName = ge;
var G = 10, [mn, fe] = Re(ge), Tr = "SelectContentImpl", Ir = Hn("SelectContent.RemoveScroll"), gn = g.forwardRef((e, t) => {
  const { __scopeSelect: n, position: o = "item-aligned", onCloseAutoFocus: r, onEscapeKeyDown: i, onPointerDownOutside: s, side: a, sideOffset: c, align: u, alignOffset: l, arrowPadding: d, collisionBoundary: m, collisionPadding: p, sticky: h, hideWhenDetached: f, avoidCollisions: y, ...x } = e, v = ue(ge, n), [S, b] = g.useState(null), [E, R] = g.useState(null), N = X(t, (C) => b(C)), [k, V] = g.useState(null), [L, H] = g.useState(null), D = $e(n), [_, I] = g.useState(!1), F = g.useRef(!1);
  g.useEffect(() => {
    if (S) return Fn(S);
  }, [S]), Kn();
  const A = g.useCallback((C) => {
    const [B, ...M] = D().map((q) => q.ref.current), [O] = M.slice(-1), K = document.activeElement;
    for (const q of C)
      if (q === K || (q?.scrollIntoView({ block: "nearest" }), q === B && E && (E.scrollTop = 0), q === O && E && (E.scrollTop = E.scrollHeight), q?.focus(), document.activeElement !== K)) return;
  }, [D, E]), T = g.useCallback(() => A([k, S]), [
    A,
    k,
    S
  ]);
  g.useEffect(() => {
    _ && T();
  }, [_, T]);
  const { onOpenChange: P, triggerPointerDownPosRef: j } = v;
  g.useEffect(() => {
    if (S) {
      let C = {
        x: 0,
        y: 0
      };
      const B = (O) => {
        C = {
          x: Math.abs(Math.round(O.pageX) - (j.current?.x ?? 0)),
          y: Math.abs(Math.round(O.pageY) - (j.current?.y ?? 0))
        };
      }, M = (O) => {
        C.x <= 10 && C.y <= 10 ? O.preventDefault() : S.contains(O.target) || P(!1), document.removeEventListener("pointermove", B), j.current = null;
      };
      return j.current !== null && (document.addEventListener("pointermove", B), document.addEventListener("pointerup", M, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", B), document.removeEventListener("pointerup", M, { capture: !0 });
      };
    }
  }, [
    S,
    P,
    j
  ]), g.useEffect(() => {
    const C = () => P(!1);
    return window.addEventListener("blur", C), window.addEventListener("resize", C), () => {
      window.removeEventListener("blur", C), window.removeEventListener("resize", C);
    };
  }, [P]);
  const [z, we] = In((C) => {
    const B = D().filter((O) => !O.disabled), M = Nn(B, C, B.find((O) => O.ref.current === document.activeElement));
    M && setTimeout(() => M.ref.current.focus());
  }), Pe = g.useCallback((C, B, M) => {
    const O = !F.current && !M;
    (v.value !== void 0 && v.value === B || O) && (V(C), O && (F.current = !0));
  }, [v.value]), se = g.useCallback(() => S?.focus(), [S]), Ee = g.useCallback((C, B, M) => {
    const O = !F.current && !M;
    (v.value !== void 0 && v.value === B || O) && H(C);
  }, [v.value]), ae = o === "popper" ? Qe : wn, Ae = ae === Qe ? {
    side: a,
    sideOffset: c,
    align: u,
    alignOffset: l,
    arrowPadding: d,
    collisionBoundary: m,
    collisionPadding: p,
    sticky: h,
    hideWhenDetached: f,
    avoidCollisions: y
  } : {};
  return /* @__PURE__ */ (0, w.jsx)(mn, {
    scope: n,
    content: S,
    viewport: E,
    onViewportChange: R,
    itemRefCallback: Pe,
    selectedItem: k,
    onItemLeave: se,
    itemTextRefCallback: Ee,
    focusSelectedItem: T,
    selectedItemText: L,
    position: o,
    isPositioned: _,
    searchRef: z,
    children: /* @__PURE__ */ (0, w.jsx)(zn, {
      as: Ir,
      allowPinchZoom: !0,
      children: /* @__PURE__ */ (0, w.jsx)(Wn, {
        asChild: !0,
        trapped: v.open,
        onMountAutoFocus: (C) => {
          C.preventDefault();
        },
        onUnmountAutoFocus: W(r, (C) => {
          v.trigger?.focus({ preventScroll: !0 }), C.preventDefault();
        }),
        children: /* @__PURE__ */ (0, w.jsx)(Un, {
          asChild: !0,
          disableOutsidePointerEvents: !0,
          onEscapeKeyDown: i,
          onPointerDownOutside: s,
          onFocusOutside: (C) => C.preventDefault(),
          onDismiss: () => v.onOpenChange(!1),
          children: /* @__PURE__ */ (0, w.jsx)(ae, {
            role: "listbox",
            id: v.contentId,
            "data-state": v.open ? "open" : "closed",
            dir: v.dir,
            onContextMenu: (C) => C.preventDefault(),
            ...x,
            ...Ae,
            onPlaced: () => I(!0),
            ref: N,
            style: {
              display: "flex",
              flexDirection: "column",
              outline: "none",
              ...x.style
            },
            onKeyDown: W(x.onKeyDown, (C) => {
              const B = C.ctrlKey || C.altKey || C.metaKey;
              if (C.key === "Tab" && C.preventDefault(), !B && C.key.length === 1 && we(C.key), [
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End"
              ].includes(C.key)) {
                let M = D().filter((O) => !O.disabled).map((O) => O.ref.current);
                if (["ArrowUp", "End"].includes(C.key) && (M = M.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(C.key)) {
                  const O = C.target, K = M.indexOf(O);
                  M = M.slice(K + 1);
                }
                setTimeout(() => A(M)), C.preventDefault();
              }
            })
          })
        })
      })
    })
  });
});
gn.displayName = Tr;
var Nr = "SelectItemAlignedPosition", wn = g.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, i = ue(ge, n), s = fe(ge, n), [a, c] = g.useState(null), [u, l] = g.useState(null), d = X(t, (R) => l(R)), m = $e(n), p = g.useRef(!1), h = g.useRef(!0), { viewport: f, selectedItem: y, selectedItemText: x, focusSelectedItem: v } = s, S = g.useCallback(() => {
    if (i.trigger && i.valueNode && a && u && f && y && x) {
      const R = i.trigger.getBoundingClientRect(), N = u.getBoundingClientRect(), k = i.valueNode.getBoundingClientRect(), V = x.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const M = V.left - N.left, O = k.left - M, K = R.left - O, q = R.width + K, ce = Math.max(q, N.width), qe = window.innerWidth - G, Ue = gt(O, [G, Math.max(G, qe - ce)]);
        a.style.minWidth = q + "px", a.style.left = Ue + "px";
      } else {
        const M = N.right - V.right, O = window.innerWidth - k.right - M, K = window.innerWidth - R.right - O, q = R.width + K, ce = Math.max(q, N.width), qe = window.innerWidth - G, Ue = gt(O, [G, Math.max(G, qe - ce)]);
        a.style.minWidth = q + "px", a.style.right = Ue + "px";
      }
      const L = m(), H = window.innerHeight - G * 2, D = f.scrollHeight, _ = window.getComputedStyle(u), I = parseInt(_.borderTopWidth, 10), F = parseInt(_.paddingTop, 10), A = parseInt(_.borderBottomWidth, 10), T = parseInt(_.paddingBottom, 10), P = I + F + D + T + A, j = Math.min(y.offsetHeight * 5, P), z = window.getComputedStyle(f), we = parseInt(z.paddingTop, 10), Pe = parseInt(z.paddingBottom, 10), se = R.top + R.height / 2 - G, Ee = H - se, ae = y.offsetHeight / 2, Ae = y.offsetTop + ae, C = I + F + Ae, B = P - C;
      if (C <= se) {
        const M = L.length > 0 && y === L[L.length - 1].ref.current;
        a.style.bottom = "0px";
        const O = u.clientHeight - f.offsetTop - f.offsetHeight, K = C + Math.max(Ee, ae + (M ? Pe : 0) + O + A);
        a.style.height = K + "px";
      } else {
        const M = L.length > 0 && y === L[0].ref.current;
        a.style.top = "0px";
        const O = Math.max(se, I + f.offsetTop + (M ? we : 0) + ae) + B;
        a.style.height = O + "px", f.scrollTop = C - se + f.offsetTop;
      }
      a.style.margin = `${G}px 0`, a.style.minHeight = j + "px", a.style.maxHeight = H + "px", o?.(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    m,
    i.trigger,
    i.valueNode,
    a,
    u,
    f,
    y,
    x,
    i.dir,
    o
  ]);
  te(() => S(), [S]);
  const [b, E] = g.useState();
  return te(() => {
    u && E(window.getComputedStyle(u).zIndex);
  }, [u]), /* @__PURE__ */ (0, w.jsx)(Mr, {
    scope: n,
    contentWrapper: a,
    shouldExpandOnScrollRef: p,
    onScrollButtonChange: g.useCallback((R) => {
      R && h.current === !0 && (S(), v?.(), h.current = !1);
    }, [S, v]),
    children: /* @__PURE__ */ (0, w.jsx)("div", {
      ref: c,
      style: {
        display: "flex",
        flexDirection: "column",
        position: "fixed",
        zIndex: b
      },
      children: /* @__PURE__ */ (0, w.jsx)($.div, {
        ...r,
        ref: d,
        style: {
          boxSizing: "border-box",
          maxHeight: "100%",
          ...r.style
        }
      })
    })
  });
});
wn.displayName = Nr;
var Lr = "SelectPopperPosition", Qe = g.forwardRef((e, t) => {
  const { __scopeSelect: n, align: o = "start", collisionPadding: r = G, ...i } = e, s = ze(n);
  return /* @__PURE__ */ (0, w.jsx)(wr, {
    ...s,
    ...i,
    ref: t,
    align: o,
    collisionPadding: r,
    style: {
      boxSizing: "border-box",
      ...i.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  });
});
Qe.displayName = Lr;
var [Mr, ht] = Re(ge, {}), et = "SelectViewport", vn = g.forwardRef((e, t) => {
  const { __scopeSelect: n, nonce: o, ...r } = e, i = fe(et, n), s = ht(et, n), a = X(t, i.onViewportChange), c = g.useRef(0);
  return /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [/* @__PURE__ */ (0, w.jsx)("style", {
    dangerouslySetInnerHTML: { __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}" },
    nonce: o
  }), /* @__PURE__ */ (0, w.jsx)(We.Slot, {
    scope: n,
    children: /* @__PURE__ */ (0, w.jsx)($.div, {
      "data-radix-select-viewport": "",
      role: "presentation",
      ...r,
      ref: a,
      style: {
        position: "relative",
        flex: 1,
        overflow: "hidden auto",
        ...r.style
      },
      onScroll: W(r.onScroll, (u) => {
        const l = u.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: m } = s;
        if (m?.current && d) {
          const p = Math.abs(c.current - l.scrollTop);
          if (p > 0) {
            const h = window.innerHeight - G * 2, f = parseFloat(d.style.minHeight), y = parseFloat(d.style.height), x = Math.max(f, y);
            if (x < h) {
              const v = x + p, S = Math.min(h, v), b = v - S;
              d.style.height = S + "px", d.style.bottom === "0px" && (l.scrollTop = b > 0 ? b : 0, d.style.justifyContent = "flex-end");
            }
          }
        }
        c.current = l.scrollTop;
      })
    })
  })] });
});
vn.displayName = et;
var yn = "SelectGroup", [kr, Dr] = Re(yn), jr = g.forwardRef((e, t) => {
  const { __scopeSelect: n, ...o } = e, r = rt();
  return /* @__PURE__ */ (0, w.jsx)(kr, {
    scope: n,
    id: r,
    children: /* @__PURE__ */ (0, w.jsx)($.div, {
      role: "group",
      "aria-labelledby": r,
      ...o,
      ref: t
    })
  });
});
jr.displayName = yn;
var xn = "SelectLabel", Vr = g.forwardRef((e, t) => {
  const { __scopeSelect: n, ...o } = e, r = Dr(xn, n);
  return /* @__PURE__ */ (0, w.jsx)($.div, {
    id: r.id,
    ...o,
    ref: t
  });
});
Vr.displayName = xn;
var je = "SelectItem", [Hr, Sn] = Re(je), bn = g.forwardRef((e, t) => {
  const { __scopeSelect: n, value: o, disabled: r = !1, textValue: i, ...s } = e, a = ue(je, n), c = fe(je, n), u = a.value === o, [l, d] = g.useState(i ?? ""), [m, p] = g.useState(!1), h = X(t, (v) => c.itemRefCallback?.(v, o, r)), f = rt(), y = g.useRef("touch"), x = () => {
    r || (a.onValueChange(o), a.onOpenChange(!1));
  };
  if (o === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
  return /* @__PURE__ */ (0, w.jsx)(Hr, {
    scope: n,
    value: o,
    disabled: r,
    textId: f,
    isSelected: u,
    onItemTextChange: g.useCallback((v) => {
      d((S) => S || (v?.textContent ?? "").trim());
    }, []),
    children: /* @__PURE__ */ (0, w.jsx)(We.ItemSlot, {
      scope: n,
      value: o,
      disabled: r,
      textValue: l,
      children: /* @__PURE__ */ (0, w.jsx)($.div, {
        role: "option",
        "aria-labelledby": f,
        "data-highlighted": m ? "" : void 0,
        "aria-selected": u && m,
        "data-state": u ? "checked" : "unchecked",
        "aria-disabled": r || void 0,
        "data-disabled": r ? "" : void 0,
        tabIndex: r ? void 0 : -1,
        ...s,
        ref: h,
        onFocus: W(s.onFocus, () => p(!0)),
        onBlur: W(s.onBlur, () => p(!1)),
        onClick: W(s.onClick, () => {
          y.current !== "mouse" && x();
        }),
        onPointerUp: W(s.onPointerUp, () => {
          y.current === "mouse" && x();
        }),
        onPointerDown: W(s.onPointerDown, (v) => {
          y.current = v.pointerType;
        }),
        onPointerMove: W(s.onPointerMove, (v) => {
          y.current = v.pointerType, r ? c.onItemLeave?.() : y.current === "mouse" && v.currentTarget.focus({ preventScroll: !0 });
        }),
        onPointerLeave: W(s.onPointerLeave, (v) => {
          v.currentTarget === document.activeElement && c.onItemLeave?.();
        }),
        onKeyDown: W(s.onKeyDown, (v) => {
          c.searchRef?.current !== "" && v.key === " " || (br.includes(v.key) && x(), v.key === " " && v.preventDefault());
        })
      })
    })
  });
});
bn.displayName = je;
var Oe = "SelectItemText", Cn = g.forwardRef((e, t) => {
  const { __scopeSelect: n, className: o, style: r, ...i } = e, s = ue(Oe, n), a = fe(Oe, n), c = Sn(Oe, n), u = Er(Oe, n), [l, d] = g.useState(null), m = X(t, (x) => d(x), c.onItemTextChange, (x) => a.itemTextRefCallback?.(x, c.value, c.disabled)), p = l?.textContent, h = g.useMemo(() => /* @__PURE__ */ (0, w.jsx)("option", {
    value: c.value,
    disabled: c.disabled,
    children: p
  }, c.value), [
    c.disabled,
    c.value,
    p
  ]), { onNativeOptionAdd: f, onNativeOptionRemove: y } = u;
  return te(() => (f(h), () => y(h)), [
    f,
    y,
    h
  ]), /* @__PURE__ */ (0, w.jsxs)(w.Fragment, { children: [/* @__PURE__ */ (0, w.jsx)($.span, {
    id: c.textId,
    ...i,
    ref: m
  }), c.isSelected && s.valueNode && !s.valueNodeHasChildren ? it.createPortal(i.children, s.valueNode) : null] });
});
Cn.displayName = Oe;
var Rn = "SelectItemIndicator", Pn = g.forwardRef((e, t) => {
  const { __scopeSelect: n, ...o } = e;
  return Sn(Rn, n).isSelected ? /* @__PURE__ */ (0, w.jsx)($.span, {
    "aria-hidden": !0,
    ...o,
    ref: t
  }) : null;
});
Pn.displayName = Rn;
var tt = "SelectScrollUpButton", En = g.forwardRef((e, t) => {
  const n = fe(tt, e.__scopeSelect), o = ht(tt, e.__scopeSelect), [r, i] = g.useState(!1), s = X(t, o.onScrollButtonChange);
  return te(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        i(c.scrollTop > 0);
      };
      const c = n.viewport;
      return a(), c.addEventListener("scroll", a), () => c.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ (0, w.jsx)(On, {
    ...e,
    ref: s,
    onAutoScroll: () => {
      const { viewport: a, selectedItem: c } = n;
      a && c && (a.scrollTop = a.scrollTop - c.offsetHeight);
    }
  }) : null;
});
En.displayName = tt;
var nt = "SelectScrollDownButton", An = g.forwardRef((e, t) => {
  const n = fe(nt, e.__scopeSelect), o = ht(nt, e.__scopeSelect), [r, i] = g.useState(!1), s = X(t, o.onScrollButtonChange);
  return te(() => {
    if (n.viewport && n.isPositioned) {
      let a = function() {
        const u = c.scrollHeight - c.clientHeight;
        i(Math.ceil(c.scrollTop) < u);
      };
      const c = n.viewport;
      return a(), c.addEventListener("scroll", a), () => c.removeEventListener("scroll", a);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ (0, w.jsx)(On, {
    ...e,
    ref: s,
    onAutoScroll: () => {
      const { viewport: a, selectedItem: c } = n;
      a && c && (a.scrollTop = a.scrollTop + c.offsetHeight);
    }
  }) : null;
});
An.displayName = nt;
var On = g.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, i = fe("SelectScrollButton", n), s = g.useRef(null), a = $e(n), c = g.useCallback(() => {
    s.current !== null && (window.clearInterval(s.current), s.current = null);
  }, []);
  return g.useEffect(() => () => c(), [c]), te(() => {
    a().find((u) => u.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [a]), /* @__PURE__ */ (0, w.jsx)($.div, {
    "aria-hidden": !0,
    ...r,
    ref: t,
    style: {
      flexShrink: 0,
      ...r.style
    },
    onPointerDown: W(r.onPointerDown, () => {
      s.current === null && (s.current = window.setInterval(o, 50));
    }),
    onPointerMove: W(r.onPointerMove, () => {
      i.onItemLeave?.(), s.current === null && (s.current = window.setInterval(o, 50));
    }),
    onPointerLeave: W(r.onPointerLeave, () => {
      c();
    })
  });
}), Fr = "SelectSeparator", Br = g.forwardRef((e, t) => {
  const { __scopeSelect: n, ...o } = e;
  return /* @__PURE__ */ (0, w.jsx)($.div, {
    "aria-hidden": !0,
    ...o,
    ref: t
  });
});
Br.displayName = Fr;
var ot = "SelectArrow", Wr = g.forwardRef((e, t) => {
  const { __scopeSelect: n, ...o } = e, r = ze(n), i = ue(ot, n), s = fe(ot, n);
  return i.open && s.position === "popper" ? /* @__PURE__ */ (0, w.jsx)(vr, {
    ...r,
    ...o,
    ref: t
  }) : null;
});
Wr.displayName = ot;
var $r = "SelectBubbleInput", _n = g.forwardRef(({ __scopeSelect: e, value: t, ...n }, o) => {
  const r = g.useRef(null), i = X(o, r), s = eo(t);
  return g.useEffect(() => {
    const a = r.current;
    if (!a) return;
    const c = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(c, "value").set;
    if (s !== t && u) {
      const l = new Event("change", { bubbles: !0 });
      u.call(a, t), a.dispatchEvent(l);
    }
  }, [s, t]), /* @__PURE__ */ (0, w.jsx)($.select, {
    ...n,
    style: {
      ...an,
      ...n.style
    },
    ref: i,
    defaultValue: t
  });
});
_n.displayName = $r;
function Tn(e) {
  return e === "" || e === void 0;
}
function In(e) {
  const t = Mt(e), n = g.useRef(""), o = g.useRef(0), r = g.useCallback((s) => {
    const a = n.current + s;
    t(a), (function c(u) {
      n.current = u, window.clearTimeout(o.current), u !== "" && (o.current = window.setTimeout(() => c(""), 1e3));
    })(a);
  }, [t]), i = g.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), [
    n,
    r,
    i
  ];
}
function Nn(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((a) => a === t[0]) ? t[0] : t, r = n ? e.indexOf(n) : -1;
  let i = zr(e, Math.max(r, 0));
  o.length === 1 && (i = i.filter((a) => a !== n));
  const s = i.find((a) => a.textValue.toLowerCase().startsWith(o.toLowerCase()));
  return s !== n ? s : void 0;
}
function zr(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var qr = cn, Ur = dn, Yr = fn, Kr = pn, Xr = hn, Gr = vn, Zr = bn, Jr = Cn, Qr = Pn, ei = En, ti = An;
function ni({ ...e }) {
  return /* @__PURE__ */ (0, w.jsx)(qr, {
    "data-slot": "select",
    ...e
  });
}
function oi({ className: e, size: t = "default", children: n, ...o }) {
  return /* @__PURE__ */ (0, w.jsxs)(Ur, {
    "data-slot": "select-trigger",
    "data-size": t,
    className: xe("border-input data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex w-fit items-center justify-between gap-2 rounded border bg-transparent p-3 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-11 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", e),
    ...o,
    children: [n, /* @__PURE__ */ (0, w.jsx)(Yr, {
      asChild: !0,
      children: /* @__PURE__ */ (0, w.jsx)(jt, { className: "size-4 opacity-50" })
    })]
  });
}
function ri({ className: e, children: t, position: n = "popper", align: o = "center", ...r }) {
  return /* @__PURE__ */ (0, w.jsx)(Kr, { children: /* @__PURE__ */ (0, w.jsxs)(Xr, {
    "data-slot": "select-content",
    className: xe("bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md", n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", e),
    position: n,
    align: o,
    ...r,
    children: [
      /* @__PURE__ */ (0, w.jsx)(si, {}),
      /* @__PURE__ */ (0, w.jsx)(Gr, {
        className: xe("p-1", n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"),
        children: t
      }),
      /* @__PURE__ */ (0, w.jsx)(ai, {})
    ]
  }) });
}
function ii({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ (0, w.jsxs)(Zr, {
    "data-slot": "select-item",
    className: xe("focus:bg-accent focus:text-accent-foreground data-[state=checked]:bg-accent data-[state=checked]:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", e),
    ...n,
    children: [/* @__PURE__ */ (0, w.jsx)("span", {
      className: "absolute right-2 flex size-3.5 items-center justify-center",
      children: /* @__PURE__ */ (0, w.jsx)(Qr, { children: /* @__PURE__ */ (0, w.jsx)(Jn, { className: "size-4" }) })
    }), /* @__PURE__ */ (0, w.jsx)(Jr, { children: t })]
  });
}
function si({ className: e, ...t }) {
  return /* @__PURE__ */ (0, w.jsx)(ei, {
    "data-slot": "select-scroll-up-button",
    className: xe("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ (0, w.jsx)(oo, { className: "size-4" })
  });
}
function ai({ className: e, ...t }) {
  return /* @__PURE__ */ (0, w.jsx)(ti, {
    "data-slot": "select-scroll-down-button",
    className: xe("flex cursor-default items-center justify-center py-1", e),
    ...t,
    children: /* @__PURE__ */ (0, w.jsx)(jt, { className: "size-4" })
  });
}
var Ln = jn(), ci = async (e, t) => {
  if (!window.__STOREFRONT_ACCESS_TOKEN__) throw new Error("Storefront access token is not set");
  const n = await fetch(`${window.Shopify.routes.root === "/" ? "" : window.Shopify.routes.root}/api/2025-07/graphql.json`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": window.__STOREFRONT_ACCESS_TOKEN__
    },
    body: JSON.stringify({
      query: e,
      variables: t
    })
  });
  if (!n.ok) throw new Error(`Response status: ${n.status}`);
  return await n.json();
};
function li({ products: e, defaultOptions: t }) {
  const n = Array.from(new Set(e.flatMap((l) => (l.options ?? []).map((d) => d.name)))).sort((l, d) => (t?.find((m) => m.name === l)?.position ?? 999) - (t?.find((m) => m.name === d)?.position ?? 999)), o = e.filter((l) => !!l.handle).map((l) => {
    const d = {};
    return n.forEach((m) => {
      d[m] = l.options?.find((p) => p.name === m)?.optionValues[0]?.name || "N/A";
    }), {
      handle: l.handle,
      options: d,
      quantityAvailable: l.variants.nodes[0]?.quantityAvailable || 0
    };
  }), r = {};
  t?.forEach((l) => {
    l.values?.[0] && (r[l.name] = l.values[0]);
  }), n.forEach((l) => {
    if (!r[l]) {
      const d = new Set(o.map((m) => m.options[l]));
      d.size === 1 && (r[l] = Array.from(d)[0]);
    }
  });
  const [i, s] = (0, g.useState)(r), a = (l) => {
    const d = o.filter((p) => Object.entries(i).every(([h, f]) => h === l ? !0 : p.options[h] === f)), m = /* @__PURE__ */ new Map();
    return d.forEach((p) => {
      const h = p.options[l], f = p.quantityAvailable > 0;
      (!m.has(h) || f) && m.set(h, f || m.get(h) || !1);
    }), Array.from(m.entries()).map(([p, h]) => ({
      value: p,
      isInStock: h
    })).sort((p, h) => {
      if (p.isInStock !== h.isInStock) return p.isInStock ? -1 : 1;
      const f = Number(p.value.match(/^\d+/)?.[0]), y = Number(h.value.match(/^\d+/)?.[0]);
      return !Number.isNaN(f) && !Number.isNaN(y) ? f - y : p.value.localeCompare(h.value);
    });
  }, c = (l, d) => {
    const m = {
      ...i,
      [l]: d
    };
    return o.find((p) => Object.entries(m).every(([h, f]) => p.options[h] === f))?.handle || null;
  }, u = (l, d) => {
    s({
      ...i,
      [l]: d
    });
    const m = c(l, d);
    m && (window.location.href = `/products/${m}`);
  };
  return /* @__PURE__ */ (0, w.jsx)("div", {
    className: "flex flex-col gap-2 mb-2",
    children: n.map((l) => {
      const d = a(l), m = i[l] || d[0]?.value, p = d.find((h) => h.value === m)?.isInStock ?? !0;
      return d.length <= 1 ? null : /* @__PURE__ */ (0, w.jsxs)(ni, {
        value: m,
        onValueChange: (h) => u(l, h),
        children: [/* @__PURE__ */ (0, w.jsx)(oi, {
          className: "w-full text-md",
          children: /* @__PURE__ */ (0, w.jsxs)("span", {
            className: "text-ellipsis overflow-hidden",
            children: [
              /* @__PURE__ */ (0, w.jsx)("b", { children: l }),
              ": ",
              m,
              !p && /* @__PURE__ */ (0, w.jsx)("span", {
                className: "text-gray-400",
                children: " - Out of Stock"
              })
            ]
          })
        }), /* @__PURE__ */ (0, w.jsx)(ri, {
          className: "bg-white max-h-60",
          children: d.map(({ value: h, isInStock: f }) => /* @__PURE__ */ (0, w.jsxs)(ii, {
            value: h,
            children: [h, !f && /* @__PURE__ */ (0, w.jsx)("span", {
              className: "text-gray-400",
              children: " - Out of Stock"
            })]
          }, h))
        })]
      }, l);
    })
  });
}
var di = class extends kt {
  async connectedCallback() {
    super.connectedCallback();
    const e = this.querySelector("[data-spinner]"), t = this.dataset.familyId;
    if (!t) {
      e && e.classList.add("hidden"), console.warn("[VariantSelector] Family ID is not found");
      return;
    }
    const n = await ci(`#graphql
    query Products($filters: [ProductFilter!]) {
      search(query: "", types: [PRODUCT], productFilters: $filters, first: 250) {
        nodes {
            ... on Product {
                id
                handle
                title
                featuredImage {
                    url
                }
                productFamilyId: metafield(namespace: "shophouzz", key: "product_family_id") {
                    value
                }
                options(first: 50) {
                    name
                    optionValues {
                        name
                    }
                }
                variants(first: 1) {
                    nodes {
                        id
                        price {
                            amount
                        }
                        compareAtPrice {
                            amount
                        }
                        quantityAvailable
                        sku
                        selectedOptions {
                            name
                            value
                        }
                    }
                }
            }
        }
      }
    }
    `, { filters: [{ productMetafield: {
      namespace: "shophouzz",
      key: "product_family_id",
      value: t
    } }] });
    if (e && e.classList.add("hidden"), !n.data?.search?.nodes?.length) {
      console.warn("[VariantSelector] No products found in the family");
      return;
    }
    const o = n.data.search.nodes, r = this.dataset.productHandle;
    if (!r || !o.length) {
      r || console.warn("[VariantSelector] Product handle is not found"), o.length || console.warn("[VariantSelector] No products found in the family"), console.warn("[VariantSelector] Product handle is not found");
      return;
    }
    const i = this.getJson("default-options");
    (0, Ln.createRoot)(this).render(/* @__PURE__ */ (0, w.jsx)(li, {
      products: o,
      defaultOptions: i
    }));
  }
};
customElements.get("hy-variant-selector") || customElements.define("hy-variant-selector", di);
var ui = class extends HTMLElement {
  constructor(...e) {
    super(...e), ve(this, "offers", []), ve(this, "product", null), ve(this, "selectedOffer", null), ve(this, "urlObserver", null), ve(this, "originalFetch", null), ve(this, "boundAddToCartHandler", null);
  }
  connectedCallback() {
    document.addEventListener("mulberry-shopify:loaded", this.onMulberryLoaded.bind(this), { once: !0 }), this.boundAddToCartHandler = this.onAddToCart.bind(this), document.querySelector(".product-form__submit[name='add']")?.addEventListener("click", this.boundAddToCartHandler);
  }
  disconnectedCallback() {
    this.urlObserver?.disconnect(), this.boundAddToCartHandler && document.querySelector(".product-form__submit[name='add']")?.removeEventListener("click", this.boundAddToCartHandler), this.originalFetch && (window.fetch = this.originalFetch);
  }
  renderOffers() {
    if (this.offers.length === 0) {
      this.classList.add("hidden");
      return;
    }
    const e = [...this.offers].sort((n, o) => Number.parseInt(n.duration_months, 10) - Number.parseInt(o.duration_months, 10)).map((n) => {
      const o = Math.floor(Number.parseInt(n.duration_months, 10) / 12), r = Gn.format(parseFloat(n.customer_cost));
      return `
          <label class="flex whitespace-nowrap items-center gap-2 cursor-pointer select-none" data-offer-id="${n.id}">
            <input type="checkbox" name="warranty-${n.id}" class="size-5 appearance-none flex items-center justify-center cursor-pointer bg-white border border-primary rounded checked:bg-icon-checkmark checked:bg-contain" />
            <span class="font-medium">${o} Year</span>
            <span>- ${r}</span>
          </label>
        `;
    }).join(""), t = this.querySelector(".mulberry-offers");
    t && (t.innerHTML = e), this.querySelectorAll('input[type="checkbox"]').forEach((n) => {
      n.addEventListener("change", (o) => this.onCheckboxChange(o));
    }), this.classList.remove("hidden");
  }
  onCheckboxChange(e) {
    const t = e.target, n = t.closest("[data-offer-id]")?.getAttribute("data-offer-id");
    this.querySelectorAll('input[type="checkbox"]').forEach((o) => {
      o !== t && (o.checked = !1);
    }), t.checked && n ? this.selectedOffer = this.offers.find((o) => o.id === n) || null : this.selectedOffer = null;
  }
  async onMulberryLoaded() {
    window.mb_gtm_is_disabled = !0, this.setupFetchListeners(), await this.removeAndSyncWarranties(), await this.initWarrantyOffers(), this.setupVariantChangeListener(), await window.mulberryShop.cart.init(), window.mulberryShop.cart.render();
  }
  async initWarrantyOffers() {
    try {
      this.product = (await window.mulberryShop.getProductData(window.mulberryShop.getProductUrl())).product, this.product.tags && this.product.tags.split(/\s*,\s*/).includes("non-returnable") && (this.product.product_type = "non-returnable");
      const e = this.getCurrentlySelectedVariant();
      if (!e) {
        this.classList.add("hidden");
        return;
      }
      this.offers = await window.mulberry.core.getWarrantyOffer({
        id: e.id,
        title: this.product.title,
        price: e.price,
        detail: this.product
      }), this.renderOffers(), await window.mulberry.faq.init({ coverage: this.offers[0] }), document.querySelector("[data-modal-trigger]")?.addEventListener("click", () => {
        window.mulberry.faq.open();
      });
    } catch (e) {
      console.error("Failed to load warranty offers:", e), this.classList.add("hidden");
    }
  }
  getCurrentlySelectedVariant() {
    if (!this.product) return null;
    let e = this.product.variants.find((t) => t.id == window.mulberryShop.selectedVariantId);
    return e || (e = this.product.variants[0]), e && (window.mulberryShop.selectedVariantId = e.id), e;
  }
  setupVariantChangeListener() {
    const e = (o) => {
      const r = new RegExp(`[\\?&]${o}=([^&#]*)`).exec(location.search);
      return r === null ? "" : decodeURIComponent(r[1].replace(/\+/g, " "));
    };
    let t = e("variant");
    const n = async () => {
      const o = e("variant");
      if (o && t !== o) {
        t = o, this.selectedOffer = null, window.mulberryShop.selectedVariantId = o;
        const r = this.getCurrentlySelectedVariant();
        r && (this.offers = await window.mulberry.core.getWarrantyOffer({
          id: r.id,
          title: this.product.title,
          price: r.price,
          detail: this.product
        }), this.renderOffers());
      }
    };
    this.urlObserver = new MutationObserver(() => n()), this.urlObserver.observe(document.body, {
      attributes: !0,
      subtree: !0,
      attributeFilter: ["href"]
    }), n();
  }
  async onAddToCart() {
    if (this.selectedOffer)
      try {
        const e = await window.mulberryShop.getWarrantyVariant(this.selectedOffer);
        await window.mulberryShop.addWarrantyToCart(e.shopify_variant_id, {
          ...this.product,
          title: this.product.title,
          variantId: window.mulberryShop.selectedVariantId,
          quantity: parseInt(document.querySelector(".quantity__select")?.value || "1", 10),
          Product: this.product.title
        }, this.selectedOffer), window.dispatchEvent(new CustomEvent("cart:change:quantity")), this.selectedOffer = null, this.querySelectorAll('input[type="checkbox"]').forEach((t) => {
          t.checked = !1;
        });
      } catch (e) {
        console.error("Failed to add warranty to cart:", e);
      }
  }
  async removeAndSyncWarranties() {
    try {
      const e = await (await fetch("/cart.js", {
        credentials: "same-origin",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })).json();
      e.items = e.items.filter((n) => n?.properties?._variantId !== "sectional");
      const t = await window.mulberryShop.removeDetachedWarranty(e);
      await window.mulberryShop.cart.syncQuantities(t);
    } catch (e) {
      console.error("Error during warranty sync:", e);
    }
  }
  setupFetchListeners() {
    this.originalFetch = window.fetch, window.fetch = async (...e) => {
      const t = typeof e[0] == "string" ? e[0] : e[0]?.url || "", n = await this.originalFetch.apply(window, e);
      return t.includes("/cart/change") && (await this.removeAndSyncWarranties(), window.dispatchEvent(new CustomEvent("cart:change:quantity"))), n;
    };
  }
};
customElements.get("hy-mulberry") || customElements.define("hy-mulberry", ui);
var fi = Date.now(), pi = (e) => {
  const t = (0, g.useMemo)(() => {
    const n = window.customerData?.id ? "userRecentlyViewed" : "recentlyViewed", o = localStorage.getItem(n);
    if (!o) return [];
    try {
      return JSON.parse(o).filter((r) => !r.expiry || r.expiry > fi).slice(0, e.config?.max_products ?? 24);
    } catch {
      console.warn("Error parsing recently viewed products");
    }
    return [];
  }, [e.config]);
  return t.length === 0 ? /* @__PURE__ */ (0, w.jsx)("div", {
    className: "text-center text-gray-500",
    children: "No recently viewed products"
  }) : /* @__PURE__ */ (0, w.jsx)(to, {
    ...e,
    data: t.map((n) => ({
      id: n.id,
      name: n.title,
      price: parseFloat(n.price) / 100,
      url: n.url,
      images: [n.image, n.image2].filter(Boolean).map((o) => o.replace("_large.", ".")),
      on_sale: n.on_sale,
      compareAtPrice: parseFloat(n.compare_price) / 100,
      manufacturer: n.vendor
    })),
    withCioAttributes: !1
  });
}, hi = class extends kt {
  async connectedCallback() {
    await super.connectedCallback();
    const e = this.getJson("config");
    (0, Ln.createRoot)(this).render(/* @__PURE__ */ (0, w.jsx)(qn, { children: /* @__PURE__ */ (0, w.jsx)(pi, {
      carousel: {
        "data-autoplay": this.dataset.autoplay,
        "data-loop": this.dataset.loop,
        "data-drag-free": this.dataset.dragFree,
        "data-controls": this.dataset.controls,
        "data-axis": this.dataset.axis
      },
      config: e,
      heading: this.dataset.heading,
      headingTag: this.dataset.headingTag,
      className: {
        heading: this.dataset.cssHeading || "",
        dots: this.dataset.cssDots || ""
      }
    }) }));
  }
};
customElements.get("hy-recently-viewed") || customElements.define("hy-recently-viewed", hi);
(function(e, t, n, o, r, i, s) {
  var a, c = e[n] || {}, u = document.createElement(i), l = document.getElementsByTagName(i)[0], d = function(m, p, h) {
    return function() {
      m[p]._.push([h, arguments]);
    };
  };
  for (c[o] = d(c, o, "set"), a = c[o], c[r] = {}, c[r]._ = [], a._ = [], c[r][s] = d(c, r, s), r = 0, s = "set add save post open empty reset on off trigger ready setProduct".split(" "); r < s.length; r++) a[s[r]] = d(c, o, s[r]);
  for (r = 0, s = [
    "get",
    "token",
    "url",
    "items"
  ]; r < s.length; r++) a[s[r]] = function() {
  };
  u.async = !0, u.src = "https://cdn1.affirm.com/js/v2/affirm.js", l.parentNode.insertBefore(u, l), a(t), e[n] = c;
})(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready");
var mi = 2.5, Mn = "product-zoom-modal", gi = "product-zoom-carousel-template", Ot = "product-zoom-modal-body", wi = '[data-testid="product-gallery"] [data-slide][data-zoom-index]', vi = "[data-zoom-slide]", yi = 'script[data-id="options"]', kn = 0;
function _t(e, t, n) {
  return Math.min(n, Math.max(t, e));
}
function Tt(e, t, n) {
  const o = e.getBoundingClientRect();
  return {
    x: _t((t - o.left) / o.width * 100, 0, 100),
    y: _t((n - o.top) / o.height * 100, 0, 100)
  };
}
function It(e, t) {
  e.closest("hy-carousel")?.dispatchEvent(new CustomEvent("magnify:zoom", { detail: { zoomed: t } }));
}
function Nt(e, t) {
  t.style.transform = "", t.style.transformOrigin = "", e.style.cursor = "zoom-in";
}
function xi(e, t) {
  let n = !1;
  e.addEventListener("click", (o) => {
    if (o.stopPropagation(), n)
      Nt(e, t), n = !1;
    else {
      const r = Tt(e, o.clientX, o.clientY);
      t.style.transformOrigin = `${r.x}% ${r.y}%`, t.style.transform = `scale(${mi})`, e.style.cursor = "zoom-out", n = !0;
    }
    It(e, n);
  }), e.addEventListener("mousemove", (o) => {
    if (!n) return;
    const r = Tt(e, o.clientX, o.clientY);
    t.style.transformOrigin = `${r.x}% ${r.y}%`;
  }), e.addEventListener("mouseleave", () => {
    n && (Nt(e, t), n = !1, It(e, !1));
  });
}
function Si(e) {
  if (window.matchMedia("(hover: hover)").matches)
    for (const t of e.querySelectorAll(vi)) {
      const n = t.querySelector("img");
      n && xi(t, n);
    }
}
function bi(e) {
  const t = document.getElementById(Mn);
  t && (kn = e, t.show());
}
function Ci(e) {
  const t = e.content.cloneNode(!0), n = t.querySelector(yi);
  if (n?.textContent) {
    const o = JSON.parse(n.textContent);
    o.startIndex = kn, n.textContent = JSON.stringify(o);
  }
  return t;
}
document.addEventListener("click", (e) => {
  const t = e.target?.closest(wi);
  if (!t) return;
  const n = Number(t.dataset.zoomIndex);
  Number.isFinite(n) && bi(n);
});
window.addEventListener("hy-modal:opened", (e) => {
  if (e.detail?.id !== Mn) return;
  const t = document.getElementById(gi), n = document.querySelector(`[data-slot="dialog-content"] #${Ot}`) ?? document.getElementById(Ot);
  !n || !t || (n.replaceChildren(Ci(t)), setTimeout(() => Si(n), 50));
});
